import React from 'react';


const AgentUtilizationPanel = ({ utilizationData }) => {
  const getUtilizationColor = (percentage) => {
    if (percentage >= 90) return 'text-error';
    if (percentage >= 75) return 'text-warning';
    if (percentage >= 50) return 'text-success';
    return 'text-muted-foreground';
  };

  const getUtilizationBg = (percentage) => {
    if (percentage >= 90) return 'bg-error';
    if (percentage >= 75) return 'bg-warning';
    if (percentage >= 50) return 'bg-success';
    return 'bg-muted';
  };

  return;














































};

export default AgentUtilizationPanel;